export const LOGGED_IN_USER = 'LOGGED_IN_USER'
export const LOGGED_IN_USER_DATA = 'LOGGED_IN_USER_DATA'
export const LOGOUT = 'LOGOUT'
export const POST_NEW_GAME = 'POST_NEW_GAME'
export const GET_ALL_USERS = 'GET_ALL_USERS'
export const GET_ALL_GAMES = 'GET_ALL_GAMES'
export const GET_CURRENT_GAME_STATUS = 'GET_CURRENT_GAME_STATUS'
export const POST_GAME_MOVE = 'POST_GAME_MOVE'
export const REMOVE_CURRENT_GAME = 'REMOVE_CURRENT_GAME'